import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { TeleprompterSettingsInteractions } from './types';

export function teleprompterSettingsInteractionEvent({
  action,
}: {
  action: TeleprompterSettingsInteractions;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.TELEPROMPTER_SETTINGS_CHANGED,
  };

  pushToDataLayer({
    ...eventAttributes,
    action,
  });
}
